import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { AuthShell, authStyles, BotaoPrimario, Aviso } from './RecuperarSenha';

const { labelStyle, inputStyle } = authStyles;

export default function NovaSenha() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [senha, setSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    if (senha.length < 6) return setErro('A senha deve ter pelo menos 6 caracteres.');
    if (senha !== confirmar) return setErro('As senhas não conferem.');
    setLoading(true);
    try {
      await api.post('/auth/nova-senha', { token, nova_senha: senha });
      navigate('/login', { replace: true, state: { sucesso: 'Senha alterada com sucesso' } });
    } catch (err) {
      setErro(err.response?.data?.error || 'Não foi possível alterar a senha. Tente novamente.');
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell titulo='Link inválido' subtitulo='Este link de recuperação está incompleto'>
        <Aviso tipo='erro'>Abra o link exatamente como chegou no email, ou solicite um novo.</Aviso>
        <Link to='/recuperar-senha' style={{ color: '#1A3A5C', fontWeight: '600', fontSize: '14px' }}>Solicitar novo link</Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell titulo='Criar nova senha' subtitulo='Digite e confirme sua nova senha'>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '14px' }}>
          <label style={labelStyle}>Nova senha</label>
          <input type='password' value={senha} onChange={e => setSenha(e.target.value)} placeholder='Mínimo 6 caracteres' required autoFocus autoComplete='new-password' style={inputStyle} />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={labelStyle}>Confirmar senha</label>
          <input type='password' value={confirmar} onChange={e => setConfirmar(e.target.value)} placeholder='Repita a nova senha' required autoComplete='new-password' style={inputStyle} />
        </div>
        {erro && (
          <Aviso tipo='erro'>
            {erro}
            {/expirado|inválido/i.test(erro) && <> <Link to='/recuperar-senha' style={{ color: '#C0392B', fontWeight: '700' }}>Solicitar novo link</Link></>}
          </Aviso>
        )}
        <BotaoPrimario loading={loading} textoLoading='Salvando...'>Salvar nova senha</BotaoPrimario>
      </form>
    </AuthShell>
  );
}
